

<div *ngIf="isInactif" class="action-co-body">
  <div class="row w-100 justify-content-center q-nodata q-c-main ">    
      <h3>
        <i class="fas fa-file-signature mr-1"></i>
        <label class="big-title">Signature électronique du document</label>
      </h3>    
  </div>
  <div class="row w-100 justify-content-center q-nodata q-c-main ">    
      <label>Veuillez contacter le service commercial pour activer cette fonctionnalité.</label>    
  </div>    
</div>

<div *ngIf="!isInactif" class="action-co-body">
  <div *ngIf="identDevis && identDevis !== '0'" >
    <q-esignature [(idBO)]="bo" [(idDonnee)]="identDevis" [(signMode)]="mode"></q-esignature>
  </div>

  <div *ngIf="!identDevis || identDevis === '0'">
    <div class="row w-100 justify-content-center q-nodata q-c-main">
      <h3>
        <i class="fas fa-file-signature  mr-1"></i>
        <label class="big-title">Signature électronique du document</label>
      </h3>      
    </div>
    <div class="row w-100 justify-content-center q-nodata q-c-main"><i class="fas fa-exclamation-circle"></i></div>
    <div class="row w-100 justify-content-center q-nodata q-c-main">Le devis n'a pas encore été généré</div>
  </div>
</div>
